// extracted by mini-css-extract-plugin
export default {"btn":"CustomButton_btn__zpKer"};